import React, { useEffect, useState } from 'react';
import { getLeaves } from '../services/api';

const LeaveList = ({ token }) => {
  const [leaves, setLeaves] = useState([]);

  useEffect(() => {
    const fetchLeaves = async () => {
      try {
        const response = await getLeaves(token);

        // Enrich leave data with additional fields
        const enrichedLeaves = response.leaves.map(leave => ({
          ...leave,
          student_name: leave.student_name || 'N/A',
          student_email: leave.student_email || 'N/A',
          first_name: leave.first_name || 'N/A',
          last_name: leave.last_name || 'N/A',
          admission_stream: leave.admission_stream || 'N/A',
          class: leave.class || 'N/A',
        }));

        setLeaves(enrichedLeaves);
      } catch (error) {
        console.error('Error fetching leaves:', error);
      }
    };
    fetchLeaves();
  }, [token]);

  const handlePrint = (leave) => {
    const printContent = `
      <div style="font-family: 'Arial', sans-serif; width: 100%; max-width: 800px; padding: 40px; margin: 0 auto; border: 1px solid #e0e0e0; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
        <div style="text-align: center; margin-bottom: 30px;">
          <h1 style="color: #A51C30; margin-bottom: 5px; font-size: 28px;">Thogoto T.T.C Leave Application</h1>
          <div style="height: 2px; background: linear-gradient(to right, transparent, #A51C30, transparent); margin: 10px 0;"></div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 30px;">
          <div>
            <h3 style="margin-bottom: 15px; color: #555; border-bottom: 1px solid #eee; padding-bottom: 5px;">Student Information</h3>
            <table style="width: 100%;">
              <tr>
                <td style="padding: 8px 0; width: 40%; font-weight: bold;">FirstName:</td>
                <td style="padding: 8px 0;">${leave.first_name}</td>
              </tr>
              <table style="width: 100%;">

              <table style="width: 100%;">
              <tr>
                <td style="padding: 8px 0; width: 40%; font-weight: bold;">lastName:</td>
                <td style="padding: 8px 0;">${leave.last_name}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; font-weight: bold;">Email:</td>
                <td style="padding: 8px 0;">${leave.student_email}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; font-weight: bold;">Class:</td>
                <td style="padding: 8px 0;">${leave.class}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; font-weight: bold;">Stream:</td>
                <td style="padding: 8px 0;">${leave.admission_stream}</td>
              </tr>
            </table>
          </div>

          <div>
            <h3 style="margin-bottom: 15px; color: #555; border-bottom: 1px solid #eee; padding-bottom: 5px;">Leave Details</h3>
            <table style="width: 100%;">
              <tr>
                <td style="padding: 8px 0; width: 40%; font-weight: bold;">Leave Type:</td>
                <td style="padding: 8px 0;">${leave.leave_type}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; font-weight: bold;">Start Date:</td>
                <td style="padding: 8px 0;">${new Date(leave.start_date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; font-weight: bold;">End Date:</td>
                <td style="padding: 8px 0;">${new Date(leave.end_date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; font-weight: bold;">Duration:</td>
                <td style="padding: 8px 0;">${Math.ceil((new Date(leave.end_date) - new Date(leave.start_date)) / (1000 * 60 * 60 * 24)) + 1} days</td>
              </tr>
            </table>
          </div>
        </div>

        <div style="margin-bottom: 30px;">
          <h3 style="margin-bottom: 15px; color: #555; border-bottom: 1px solid #eee; padding-bottom: 5px;">Reason for Leave</h3>
          <div style="background: #f9f9f9; padding: 15px; border-radius: 4px; border-left: 4px solid #A51C30;">
            <p style="margin: 0; line-height: 1.6;">${leave.reason}</p>
          </div>
        </div>

        <div style="margin-bottom: 30px;">
          <h3 style="margin-bottom: 15px; color: #555; border-bottom: 1px solid #eee; padding-bottom: 5px;">Review Information</h3>
          <table style="width: 100%;">
            <tr>
              <td style="padding: 8px 0; width: 40%; font-weight: bold;">Reviewed By:</td>
              <td style="padding: 8px 0;">${leave.reviewed_by || 'N/A'}</td>
            </tr>
          </table>
        </div>

        <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 40px;">
          <div style="width: 45%;">
            <div style="border-top: 1px solid #000; width: 80%; padding-top: 5px;">
              <p style="margin: 0; font-weight: bold;">Student Signature</p>
            </div>
          </div>

          <div style="width: 45%; text-align: right; position: relative;">
          <!-- Administration Watermark Behind Signature -->
          <div style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-15deg);
            font-size: 24px;
            font-weight: bold;
            color: rgba(165, 28, 48, 0.15);
            z-index: 0;
            white-space: nowrap;
            pointer-events: none;
            font-family: 'Times New Roman', serif;
            letter-spacing: 2px;
          ">
            ADMINISTRATION
          </div>

          <div style="width: 80%; margin-left: auto; padding-bottom: 10px; position: relative; z-index: 1;">
            <!-- Realistic Signature -->
            <svg width="200" height="60" viewBox="0 0 200 60" style="overflow: visible;">
              <path
                d="M10,30 Q25,10 40,30 T70,30 T100,30 T130,30 T160,30"
                stroke="#333"
                stroke-width="2"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="filter: drop-shadow(1px 1px 1px rgba(0,0,0,0.2));"
              />
              <path
                d="M160,30 Q175,15 190,30"
                stroke="#333"
                stroke-width="2"
                fill="none"
                stroke-linecap="round"
              />
              <path
                d="M190,30 L195,25"
                stroke="#333"
                stroke-width="1.5"
                fill="none"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <div style="border-top: 1px solid #000; width: 60%; margin-left: auto; padding-top: 5px; position: relative; z-index: 1;">
            <p style="margin: 0; font-weight: bold; font-size: 14px;">Authorized Signature</p>
            <p style="margin: 2px 0 0 0; font-size: 12px; color: #555;">Date: ${new Date().toLocaleDateString()}</p>
          </div>
        </div>

        <div style="position: absolute; top: 40px; right: 40px;">
          <div style="
            width: 100px;
            height: 100px;
            border-radius: 50%;
            border: 3px solid ${getStatusColor(leave.status)};
            display: flex;
            align-items: center;
            justify-content: center;
            transform: rotate(-15deg);
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
            background: rgba(255,255,255,0.9);
          ">
            <span style="
              color: ${getStatusColor(leave.status)};
              font-weight: bold;
              font-size: 16px;
              text-transform: uppercase;
              text-align: center;
            ">
              ${leave.status || 'N/A'}
            </span>
          </div>
        </div>
      </div>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Leave Application - ${leave.student_name}</title>
          <style>
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                margin: 0;
                padding: 0;
              }
              @page {
                size: A4;
                margin: 20mm;
              }
            }
          </style>
        </head>
        <body>
          ${printContent}
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                window.onafterprint = function() {
                  setTimeout(function() {
                    window.close();
                  }, 500);
                };
              }, 200);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved':
        return '#2e7d32';
      case 'pending':
        return '#ff8f00';
      case 'rejected':
        return '#c62828';
      default:
        return '#333';
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Leave Applications</h2>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.headerRow}>
                <th style={styles.headerCell}>Student Name</th>
                <th style={styles.headerCell}>Student Email</th>
                <th style={styles.headerCell}>First Name</th>
                <th style={styles.headerCell}>Last Name</th>
                <th style={styles.headerCell}>Admission Stream</th>
                <th style={styles.headerCell}>Class</th>
                <th style={styles.headerCell}>Leave Type</th>
                <th style={styles.headerCell}>Start Date</th>
                <th style={styles.headerCell}>End Date</th>
                <th style={styles.headerCell}>Reason</th>
                <th style={styles.headerCell}>Status</th>
                <th style={styles.headerCell}>Print</th>
              </tr>
            </thead>
            <tbody>
              {leaves.map((leave) => (
                <tr key={leave.id} style={styles.row}>
                  <td style={styles.cell}>{leave.student_name}</td>
                  <td style={styles.cell}>{leave.student_email}</td>
                  <td style={styles.cell}>{leave.first_name}</td>
                  <td style={styles.cell}>{leave.last_name}</td>
                  <td style={styles.cell}>{leave.admission_stream}</td>
                  <td style={styles.cell}>{leave.class}</td>
                  <td style={styles.cell}>{leave.leave_type}</td>
                  <td style={styles.cell}>{new Date(leave.start_date).toLocaleString()}</td>
                  <td style={styles.cell}>{new Date(leave.end_date).toLocaleString()}</td>
                  <td style={styles.cell}>{leave.reason}</td>
                  <td style={styles.cell}>
                    <span style={getStatusStyle(leave.status)}>
                      {leave.status || 'N/A'}
                    </span>
                  </td>
                  <td style={styles.cell}>
                    <button onClick={() => handlePrint(leave)} style={styles.printButton}>
                      Print
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const getStatusStyle = (status) => {
  const baseStyle = {
    padding: '0.25rem 0.5rem',
    borderRadius: '4px',
    fontSize: '0.875rem',
    fontWeight: '500',
  };

  if (!status) {
    return {
      ...baseStyle,
      backgroundColor: '#f0f0f0',
      color: '#333',
    };
  }

  switch (status.toLowerCase()) {
    case 'approved':
      return {
        ...baseStyle,
        backgroundColor: '#e6f7e6',
        color: '#2e7d32',
      };
    case 'pending':
      return {
        ...baseStyle,
        backgroundColor: '#fff8e1',
        color: '#ff8f00',
      };
    case 'rejected':
      return {
        ...baseStyle,
        backgroundColor: '#ffebee',
        color: '#c62828',
      };
    default:
      return {
        ...baseStyle,
        backgroundColor: '#f0f0f0',
        color: '#333',
      };
  }
};

const styles = {
  container: {
    padding: '2rem',
    fontFamily: "'Georgia', serif",
  },
  card: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    maxWidth: '1200px',
    margin: '0 auto',
    borderTop: '4px solid #A51C30',
  },
  title: {
    color: '#A51C30',
    marginBottom: '2rem',
    fontSize: '1.8rem',
  },
  tableContainer: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  headerRow: {
    backgroundColor: '#f5f5f5',
    borderBottom: '2px solid #ddd',
  },
  headerCell: {
    padding: '1rem',
    textAlign: 'left',
    fontWeight: '600',
    color: '#333',
  },
  row: {
    borderBottom: '1px solid #eee',
    '&:hover': {
      backgroundColor: '#f9f9f9',
    },
  },
  cell: {
    padding: '1rem',
    color: '#555',
  },
  printButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#A51C30',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

export default LeaveList;
